
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/special",
      function () {
        return require("private-next-pages/services/special.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/special"])
      });
    }
  